import { BaseFormKitModule } from './../base/base-form-kit.module';

import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { BaseFormKitComponent } from '../base/base-form-kit.component';
import { ValidationErrorsComponent } from './../validations/validation-errors/validation-errors.component';
import { CursorPointerDirective } from './cursor-pointer.directive';
import { FormFieldNumberSeparatorPipe } from './form-field-number-separator.pipe';
import { FormFieldOnlyNumberDirective } from './form-field-only-number.directive';
import { FormFieldType } from './form-field-type.type';
import { maxNumberValidator } from './validators/max-number-validator';
import { minNumberValidator } from './validators/min-number-validator';

@Component({
    selector: 'form-field',
    imports: [
        CommonModule,
        BaseFormKitModule,
        ValidationErrorsComponent,
        FormFieldNumberSeparatorPipe,
        FormFieldOnlyNumberDirective,
        CursorPointerDirective,
    ],
    templateUrl: './form-field.component.html',
    styleUrl: '../base/base-form-kit.scss'
})
export class FormFieldComponent extends BaseFormKitComponent implements OnInit {
  //#region properties

  @Input() type: FormFieldType = 'text';
  @Input() maxLength: number;
  @Input() minLength: number;
  @Input() max: number;
  @Input() min: number;
  @Input() step: number = 1;
  @Input() isOnlyNumber: boolean = false;
  @Input() isAutoComplete: boolean = false;
  @Input() isMobileField: boolean = false;
  @Input() hasPercent: boolean = false;
  @Input() hasNumberSeparator: boolean = false;
  @Input() hasCurrency: boolean = false;
  @Input() currency: string = 'common.currency';

  @Output('input') formFieldInput = new EventEmitter<any>();
  isShowPassword: boolean = false;
  inputChangeEvent: any;

  //#region endregion

  override ngOnInit(): void {
    this.emitValue();
    this.checkAppDirectionByHtmlDirection();
  }

  override ngOnChanges(changes: any): void {
    try {
      if (changes.isDisabled) this.handleEnableStateControl();

      // default place holder for mbile type
      if (changes.isMobileField && !this.placeholder && this.isMobileField)
        this.placeholder = '09XXXXXXXXX';

      // default set is only number for tel type
      if (changes.type && this.type == 'tel') this.isOnlyNumber = true;

      // check for set validations
      if (
        changes?.maxLength ||
        changes?.minLength ||
        changes?.max ||
        changes?.min ||
        changes?.required
      )
        this.setValidations();
    } catch (error) {
      console.error('FormField Error => ', error);
    }
  }

  setValidations() {
    try {
      if (!this.control) {
        if (
          this.maxLength ||
          this.minLength ||
          this.min ||
          this.max ||
          this.required
        )
          this.control = new FormControl();
        else return;
      }

      if (this.maxLength)
        (this.control as FormControl)?.addValidators(
          Validators.maxLength(this.maxLength)
        );
      if (this.minLength)
        (this.control as FormControl)?.addValidators(
          Validators.maxLength(this.maxLength)
        );
      if (this.min)
        (this.control as FormControl)?.addValidators(
          minNumberValidator(this.min)
        );
      if (this.max)
        (this.control as FormControl)?.addValidators(
          maxNumberValidator(this.max)
        );
      if (this.required)
        (this.control as FormControl)?.addValidators(Validators.required);

      (this.control as FormControl)?.updateValueAndValidity();
    } catch (error) {
      console.error('FormField Error => ', error);
    }
  }

  //#region emit

  override emitValue() {
    try {
      const value = this.hasNumberSeparator
        ? +(this.value as string)?.toString()?.replace(/,/gi, '')
        : this.value;
      this.valueChange.emit(value);
    } catch (error) {
      console.error('FormField Error => ', error);
    }
  }

  emitInputEvent(event) {
    this.inputChangeEvent = event;
    this.formFieldInput.emit(event);
  }

  //#endregion
}
